<template>
  <div class="app-password-simple_aps">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`input-group-${i}`"
        class="input-group"
        @click="removeError(i)">

        <el-input
          v-model="valueLocal[i]"
          v-bind="widgetOptions"
          type="password"
          :class="{ 'child-has-error': error[i] }"
          clearable
          :key="`input-${i}`"/>

        <div v-if="error[i]" class="ait_message ait_message--error">{{ error[i] }}</div>

      </div>

    </div>

    <input-example :example="options.example"/>

    <add-rem-btns/>

  </div>
</template>

<script>
import approve from 'approvejs';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: '',
      errorBase: '',
    };
  },

  created() {
    if (this.options.placeholder) this.widgetOptions.placeholder = this.options.placeholder;
  },

  methods: {

    getError() {
      // Validate required
      if (this.options.required) {
        this.valueLocal.forEach((value, i) => {
          const result = approve.value(value, { required: true });
          this.error[i] = result.approved ? '' : this.validateMessages.required;
        });
      }
      this.updateValue();
      return this.error;
    },

  },

};
</script>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppPasswordSimple.vue